import { VOMarker } from "../model/Structure.js";
import { Pano } from "./Pano.js";
import { Language } from "../model/Language.js";

export class Marker2d {
    public element: HTMLDivElement;
    public position3d: THREE.Vector3;
    public position2d: { x: number; y: number };
    public width: number = 0;
    public height: number = 0;
    private _visible: boolean = true;
    public content: HTMLDivElement;

    constructor(public data: VOMarker, private pano: Pano) {
        this.setPosition(data.marker_x, data.marker_y);

        this.element = document.createElement("div");
        this.element.className = "marker-item";
        data.marker2d = this;

        var content = document.createElement("div");
        content.className = "marker-content";
        content.setAttribute("data-action", data.marker_action);
        this.element.appendChild(content);
        this.content = content;

        if (data.marker_label || data.marker_label_de) {
            var label = document.createElement("div");
            label.classList.add("marker-label");
            content.appendChild(label);

            var labelText = document.createElement("div");
            labelText.classList.add("marker-label-text");
            Language.apply(labelText, data.marker_label_de, data.marker_label);
            label.appendChild(labelText);
        }

        if (data.marker_text || data.marker_text_de) {
            var text = document.createElement("div");
            text.classList.add("marker-text");
            Language.apply(text, data.marker_text_de, data.marker_text);
            content.appendChild(text);
        }

        if (data.marker_icon) {
            var icon = document.createElement("div");
            icon.classList.add("marker-icon", "icon-" + data.marker_icon);
            content.appendChild(icon);
        }

        //We set preventTouch to false to get the browser-mouse-hover emulation.
        // var click = new e5.Click(this.element, { preventTouch: false });
        var click = new e5.Click(this.element);
        click.onClick.add(() => {
            if (this.pano.options.debug)
                return;
            if (data.marker_action == "video") {
                pano.load(data.marker_video, "marker2d");
            }
        });

        if (this.pano.options.debug && data.index !== undefined) {
            this.setDebugDragger();
        }

        if (data.marker_action === "text") {
            var isActive = false;
            this.element.addEventListener("touchstart", () => {
                if (isActive)
                    return;
                isActive = true;
                content.classList.add("active");
            });

            document.body.addEventListener("touchstart", (e) => {
                if (!isActive)
                    return;
                var t = e.target;
                if (this.element != t && !this.element.contains(t as HTMLElement)) {
                    content.classList.remove("active");
                    isActive = false;
                }
            }, true);
        }
    }

    private setDebugDragger(): void {
        var data = this.data;

        var mouseMove = (e: MouseEvent) => {
            if (!e.ctrlKey)
                return;
            e.stopImmediatePropagation();
            e.preventDefault();
            var pos = this.pano.view.toPosition(e.clientX, e.clientY);
            if (pos) {
                data.marker_x = pos.x;
                data.marker_y = pos.y;
                this.pano.acfBridge.setMarkerPosition(this.data.index, pos.x, pos.y);
                this.setPosition(data.marker_x, data.marker_y);
            }
        };
        var mouseUp = (e: MouseEvent) => {
            document.removeEventListener("mousemove", mouseMove);
            document.removeEventListener("mouseup", mouseUp);
            e.stopImmediatePropagation();
        };
        this.element.addEventListener("mousedown", (e) => {
            if (!e.ctrlKey)
                return;
            e.preventDefault();
            e.stopImmediatePropagation();
            document.addEventListener("mousemove", mouseMove);
            document.addEventListener("mouseup", mouseUp);
        });
    }

    private setPosition(x: number, y: number): void {
        var lat = x * 360 - 180;
        var lng = (1 - y) * 180 - 90;

        var lambda = (lat + 180) * Math.PI / 180;
        var phi = lng * Math.PI / 180;
        var cosPhi = Math.cos(phi);
        var radius = 8;

        this.position3d = new THREE.Vector3();
        this.position3d.x = radius * cosPhi * Math.cos(lambda);
        this.position3d.y = radius * Math.sin(phi);
        this.position3d.z = radius * cosPhi * Math.sin(lambda);

        this.position2d = { x: x, y: y };
    }

    public get visible(): boolean {
        return this._visible;
    }

    public set visible(v: boolean) {
        if (this._visible == v)
            return;
        this._visible = v;
        this.element.classList.toggle("hidden", !v);
    }
}